var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pop-ceil" }, [
    _c("div", { staticClass: "pop-box" }, [
      _c("header", [
        _c("span", { staticClass: "close-btn", on: { click: _vm.close } }, [
          _vm._v(" X")
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "pop-btns" }, [
        _c(
          "p",
          {
            directives: [{ name: "throttle", rawName: "v-throttle" }],
            on: { click: _vm.confirm }
          },
          [_vm._v("确定")]
        ),
        _vm._v(" "),
        _c("p", { on: { click: _vm.close } }, [_vm._v("取消")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pop-content" }, [
      _c("p", [_c("span"), _vm._v(" 确定要删除此商品吗?")]),
      _vm._v(" "),
      _c("p", [_vm._v("删除后采购单将不存在该商品，确定要删除吗？")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-dc49d814", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dc49d814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/shopping-trolley/deleteGoods.vue
// module id = null
// module chunks = 